import { createSelector } from 'reselect';
import { getLocalizedString } from '@synergy/utils';

import { AppState } from '../../store/store';
import { HeaderBanner } from '../models/header-banner';
import { HeaderBannersState } from './header-banner-reducer';
import { localesSelector } from './configuration-selectors';

const headerBannersState = (state: AppState): HeaderBannersState => state.headerBanners;

export const headerBannerSelector = createSelector(localesSelector, headerBannersState, (locales, state) => ({
    items: state.activeHeaderBanners.items.map<HeaderBanner>(headerBanner => ({
        ...headerBanner,
        image: headerBanner.image?.['1920x400'] ?? '',
        mobileImage: headerBanner.mobileImage?.['375x375'] ?? '',
        headline: getLocalizedString(locales, headerBanner.headline),
        subHeadline: getLocalizedString(locales, headerBanner.subHeadline),
        buttonText: getLocalizedString(locales, headerBanner.buttonText),
        buttonUrl: getLocalizedString(locales, headerBanner.buttonUrl),
    })),
    total: state.activeHeaderBanners.total,
    page: state.activeHeaderBanners.page,
    pages: state.activeHeaderBanners.pages,
}));
